// messageCenter/noticeText.js — the topoEditor entities of notice texts: links and document links {id}, no ticket
// references (D-33: most receivers cannot open tickets). Ticket texts add T#123 on top (ticketText.js). Shared by the
// inbox page and the notice window on every backend page (phase 8), so it stays small.
import { str } from '../i18n/str.js';
import { linkEntity } from '../topoEditor/entities/link.js';
import { docLinkEntity } from '../topoEditor/entities/docLink.js';

export function noticeTextEntities() {
    return [
        linkEntity({ labels: { title: str('EDITOR_LINK_EDIT'), button: str('EDITOR_LINK'),
                               textField: str('EDITOR_FIELD_TEXT'), urlField: str('EDITOR_FIELD_URL') } }),
        docLinkEntity({ labels: { title: str('EDITOR_DOCLINK'), button: str('EDITOR_DOC'),
                                  idField: str('EDITOR_FIELD_DOC_ID'), tokenTitle: str('DOCUMENT') } }),
    ];
}
